<template>
	<div class="row">
		<audio id="audio-message" :src="urlsound"></audio>
		<div class="conversation" v-if="contact && messages.length > 0">
			<div v-for="message in messages" class="col-12" :key="message.id">
				<div
					:class="
						message.to == contact.id
							? 'd-flex justify-content-end'
							: 'd-flex justify-content-start'
					"
				>
					<div
						:class="`card-message p-2 m-2 ${
							message.to == contact.id
								? 'user-destination received float-right'
								: 'user-auth sent right float-left'
						}`"
					>
						<p class="m-0 mb-2">
							<span class="font-weight-bold float-left mr-3">
								{{ message.to == contact.id ? "Você" : message.from_contact.name }}
							</span>
							<small class="font-weight-light float-right">{{
								message.created_at | moment("DD/MM/YYYY HH:mm")
							}}</small>
						</p>
						<div class="row px-3" style="display: contents">
							<p v-html="message.text"></p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-if="messages.length <= 0 && contact" class="conversation col-12">
			<h3 class="text-muted text-center" style="margin-top: 40% !important">
				Diga olá
				{{ type == "contatos" ? `para ${contact.name}` : "no grupo" }}
				😀
			</h3>
		</div>
		<div v-if="!contact" class="conversation col-12">
			<div class="text-center" style="margin-top: 20% !important">
				<span v-if="box == 'suporte'">
					<h3>Está com alguma dificuldade ou dúvida?</h3>
					<h3>Manda pra gente que te ajudamos 😉</h3>
				</span>
				<h3 v-else>
					Escolha
					{{ type == "contatos" ? "uma pessoa" : "um grupo" }} ao lado para iniciar uma
					conversa.
				</h3>
			</div>
		</div>
		<div
			class="col-12 load-text py-2 d-flex justify-content-center"
			style="
				position: absolute;
				background: aliceblue;
				bottom: 100px;
				padding: 10px;
				opacity: 0.9;
			"
			v-if="loadmessage"
		>
			<hollow-dots-spinner :animation-duration="3000" :size="60" :color="'#fb8994'" />
		</div>
		<div
			class="col-12 load-text row px-3"
			style="
				position: absolute;
				background: aliceblue;
				bottom: 100px;
				padding: 10px;
				opacity: 0.9;
			"
			v-if="writemessage"
		>
			<hollow-dots-spinner :animation-duration="3000" :size="60" :color="'#fb8994'" />
			<b class="pr-2" v-if="contact">{{ contact.name }} </b> está digitando
		</div>
	</div>
</template>

<script>
import { HollowDotsSpinner } from "epic-spinners";
export default {
	components: {
		HollowDotsSpinner,
	},
	props: {
		contact: {
			type: Object,
		},
		type: {
			type: String,
		},
		box: { type: String },
		messages: {
			type: Array,
			required: true,
		},
		loadmessage: { type: Boolean },
		writemessage: { type: Boolean, default: false },
	},
	data() {
		return {
			urlsound: `${window.location.protocol}//${window.location.host}/sound/message-pop-up.mp3`,
		};
	},
	mounted() {
		this.scrollToBottom();
	},
	beforeMount() {
		this.scrollToBottom();
	},
	methods: {
		scrollToBottom() {
			setTimeout(() => {
				if (document.getElementById("msn-list")) {
					document.getElementById("msn-list").scroll({
						top: document.getElementById("msn-list").scrollHeight,
						left: 0,
					});
				}
			}, 50);
		},
		beep() {
			var audio = document.getElementById("audio-message");
			if (audio) {
				let startPlayPromise = audio.play();

				if (startPlayPromise !== undefined) {
					startPlayPromise
						.then(() => {
							// Start whatever you need to do only after playback
							// has begun.
							//console.log("bibou?");
						})
						.catch((error) => {
							if (error.name === "NotAllowedError") {
								// showPlayButton(audio);
							} else {
								// Handle a load or playback error
							}
						});
				}
			}
		},
	},
	watch: {
		contact(contact) {
			this.scrollToBottom();
		},
		messages(messages) {
			this.scrollToBottom();
			setTimeout(() => {
				this.beep();
			}, 50);
		},
	},
};
</script>

<style lang="scss" scoped>
.card-message {
	position: relative;
	display: flex;
	flex-direction: column;
	min-width: 0;
	word-wrap: break-word;
	background-color: #fff;
	background-clip: border-box;
	border: 1px solid #fdfdff !important;
	border-radius: 1rem;
}
::-webkit-scrollbar-track {
	background-color: #f4f4f4;
}
::-webkit-scrollbar {
	width: 5px;
	background: #f4f4f4;
}
::-webkit-scrollbar-thumb {
	background: #979797;
	border-radius: 25em;
}
.direct-chat-info {
	display: block;
	margin-top: 15px;
}
.user-destination {
	background: #bbdefb;
}
.user-auth {
	background: #b2dfdb;
}
.msn {
	overflow-y: scroll;

	ul {
		list-style-type: none;
		padding: 5px;

		li {
			&.message {
				margin: 10px 0;
				width: 100%;

				.text {
					max-width: 200px;
					border-radius: 5px;
					padding: 12px;
					display: inline-block;
				}

				&.received {
					text-align: right;

					.text {
						background: #b2b2b2;
					}
				}

				&.sent {
					text-align: left;

					.text {
						background: #81c4f9;
					}
				}
			}
		}
	}
}
.user-auth.sent:before {
	content: "";
	position: absolute;
	top: 0;
	left: -6px;
	width: 0;
	height: 0;
	border: 8px solid transparent;
	border-right-color: #b2dfdb;
	border-top-color: #b2dfdb;
}
.user-destination.received:before {
	content: "";
	position: absolute;
	top: 0;
	right: -6px;
	-moz-transform: scaleY(-1);
	-o-transform: scaleY(-1);
	-webkit-transform: scaleY(-1);
	transform: scaleY(-1);
	width: 0;
	height: 0;
	border: 8px solid transparent;
	border-left-color: #bbdefb;
	border-bottom-color: #bbdefb;
}

#msn {
	// height: 60vh;
	overflow-y: auto;
	overflow-x: hidden;
}

@media (min-width: 767px) AND (max-width: 1200px) {
	#msn {
		// height: 50vh;
		overflow-y: auto;
		overflow-x: hidden;
	}
}
</style>
